module.exports = __webpack_public_path__ + "static/media/visa.6470fb6d.png";